import React from 'react'

import { P } from '@mxenabled/mxui'

import Box from '@mui/material/Box'

interface LeftBoxProps {
  leftLowerText: string
  leftUpperText: string
}

export const LeftBox: React.FC<LeftBoxProps> = ({ leftLowerText, leftUpperText }) => {
  return (
    <Box
      sx={{
        bgcolor: 'background.default',
        borderRadius: '4px',
        p: 12,
        textAlign: 'center',
        width: '100%',
      }}
    >
      <P
        data-ui-test="mx-insights-sudd-left-upper-text"
        sx={{ color: 'secondary.light' }}
        variant="caption"
      >
        {leftUpperText}
      </P>
      <P bold={true} data-ui-test="mx-insights-sudd-left-lower-text" variant="body2">
        {leftLowerText}
      </P>
    </Box>
  )
}
